import { useContext } from 'react';
import { TokenContext } from './token_context';

export function useTokenContext() {
  const context = useContext(TokenContext);

  if (typeof context === 'undefined') {
    throw new Error('useTokenContext must be used within a TokenContextProvider');
  }

  return context;
}
